export type OrderApiCredentialsResponse = OrderApiCredentials[];

export type OrderApiCredentials = {
  merchant_id: string;
  venues: string[];
  api_key_id?: string;
  webhook_id?: string;
  created_at: string;
  id: string;
};

export type NullableOrderApiCredentials = OrderApiCredentials | null;

export type OrderApiKeyResponse = {
  merchant_id: string;
  api_key: string;
  id: string;
};

export type OrderApiWebhookRegistrationPayload = {
  webhook_url: string;
  client_secret: string;
};

export type OrderApiWebhookData = {
  credential_id: string;
  merchant_id: string;
  url: string;
  subscribed_statuses: OrderApiNotificationStatus[];
  id: string;
};

export type NullableOrderApiWebhookResponse = OrderApiWebhookData | null;

export type OrderApiStatusSubscriptionPayload = {
  statuses: OrderApiNotificationStatus[];
};

export enum OrderApiNotificationStatus {
  CREATED = 'CREATED',
  PRODUCTION = 'PRODUCTION',
  READY = 'READY',
  DELIVERED = 'DELIVERED',
  CANCELED = 'CANCELED',
}
